import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wpcm-amount-box" }
const _hoisted_2 = { class: "wpcm-donation-amt-fields" }
const _hoisted_3 = {
  key: 0,
  class: "el-custom-select"
}
const _hoisted_4 = {
  key: 1,
  class: "el-custom-select"
}
const _hoisted_5 = {
  key: 2,
  class: "el-custom-select"
}
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "wpcm-cstm-amt-txt" }
const _hoisted_8 = {
  key: 4,
  class: "wpcm-pre-dfind-amt"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 5,
  class: "wpcm-pre-dfind-amt"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 6,
  class: "wpcm-reward-images"
}
const _hoisted_13 = { class: "reward-preview" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = { class: "reward-description" }
const _hoisted_16 = {
  key: 7,
  class: "wpcm-reward-images"
}
const _hoisted_17 = { class: "reward-preview" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = { class: "reward-description" }
const _hoisted_20 = {
  key: 8,
  class: "wpcm-80g-field"
}
const _hoisted_21 = { key: 9 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Currency Select "),
      ($props.show_currency_dropdown && $setup.props.currencies)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_el_select, {
              class: "w-100",
              modelValue: $setup.store.currency,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.store.currency) = $event)),
              onChange: _cache[1] || (_cache[1] = ($event: any) => ($setup.store.currency = $event))
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.currencies, (curr, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: key,
                    key: key,
                    label: curr
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(curr), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Custom Select "),
      ($props.show_custom_dropdown)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_select, {
              class: "w-100",
              modelValue: $setup.store.extras.donation_custom_dropdown,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.store.extras.donation_custom_dropdown) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => ($setup.setValue('donation_custom_dropdown', $event))),
              placeholder: "Select Any Honoree "
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.donation_custom_dropdown, (curr, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    value: key,
                    key: key,
                    label: curr
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(curr), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Causes Select "),
      ($props.show_causes_dropdown)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_select, {
              class: "w-100",
              modelValue: $setup.store.selectedCause,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.store.selectedCause) = $event)),
              onChange: _cache[5] || (_cache[5] = ($event: any) => ($setup.setValue('selectedCause', $event))),
              placeholder: "Select Any Cause"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.causes_list, (cause, key) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: key,
                    value: key,
                    label: cause
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(cause), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "label"]))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
          ]))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "donation_dropdowns"),
      _createCommentVNode(" Amount Title "),
      ($props.strings && $setup.props.show_amounts && $setup.props.amounts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("strong", _hoisted_7, _toDisplayString($props.strings.how_much), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Predefined Amounts "),
      ($setup.props.show_amounts && $setup.props.amounts && !$setup.store.recurring)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.amounts, (amnt) => {
              return (_openBlock(), _createElementBlock("li", {
                key: amnt,
                onClick: _withModifiers(($event: any) => ($setup.store.amount = $setup.convert(amnt)), ["prevent"])
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(['wpdonation-button', $setup.store.amount == $setup.convert(amnt) && 'active'])
                }, _toDisplayString($setup.getSymbol()) + _toDisplayString($setup.convert(amnt)), 3 /* TEXT, CLASS */)
              ], 8 /* PROPS */, _hoisted_9))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Recurring Amounts "),
      ($setup.props.show_amounts && $setup.props.amounts_recurring && $setup.store.recurring)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.amounts_recurring, (amnt) => {
              return (_openBlock(), _createElementBlock("li", {
                key: amnt,
                onClick: _withModifiers(($event: any) => ($setup.store.amount = $setup.convert(amnt)), ["prevent"])
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(['wpdonation-button', $setup.store.amount == $setup.convert(amnt) && 'active'])
                }, _toDisplayString($setup.getSymbol()) + _toDisplayString($setup.convert(amnt)), 3 /* TEXT, CLASS */)
              ], 8 /* PROPS */, _hoisted_11))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Reward Images for One-Time Donations "),
      ($props.show_reward_images && !$setup.store.recurring && $setup.matchingRewardIndex !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("img", {
                src: $setup.props.reward_images[$setup.matchingRewardIndex],
                alt: 'Reward for ' + $setup.store.amount + ' donation',
                class: "reward-image"
              }, null, 8 /* PROPS */, _hoisted_14),
              _createElementVNode("p", _hoisted_15, _toDisplayString($setup.props.reward_images_text), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Reward Images for Recurring Donations "),
      ($props.show_reward_images_recurring && $setup.store.recurring && $setup.matchingRecurringRewardIndex !== -1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("img", {
                src: $setup.props.recurring_images[$setup.matchingRecurringRewardIndex],
                alt: 'Recurring Reward for ' + $setup.store.amount + ' donation',
                class: "reward-image"
              }, null, 8 /* PROPS */, _hoisted_18),
              _createElementVNode("p", _hoisted_19, _toDisplayString($setup.props.reward_images_text), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 80G Selection Field "),
      ($props.enable_80g_code_field)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_el_checkbox, {
              required: "",
              modelValue: $setup.store.extras['80g_code'],
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.store.extras['80g_code']) = $event)),
              label: "I would like to claim 80G tax exemption"
            }, null, 8 /* PROPS */, ["modelValue"])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Display Amount "),
      (!$setup.props.show_amounts && $setup.props.display_amount)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.getSymbol()) + _toDisplayString($setup.props.display_amount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}